import { render, staticRenderFns } from "./HubQuickMatch.vue?vue&type=template&id=497868c4&scoped=true"
import script from "./HubQuickMatch.vue?vue&type=script&lang=js"
export * from "./HubQuickMatch.vue?vue&type=script&lang=js"
import style0 from "./HubQuickMatch.vue?vue&type=style&index=0&id=497868c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497868c4",
  null
  
)

export default component.exports